module.exports = __webpack_public_path__ + "img/consorzio-tutela-vini-valtellina.cabaf4d0.png";